import { createStore } from 'vuex'

export default createStore({
  state: {
    words: [],
    menu: [],
    footer: '',
    isLoading: false
  },
  getters: {
  },
  mutations: {
    setWords(state, payload) {
      state.words = payload.words
    },
    setLayout(state, payload) {
      state.menu = payload.menu || []
      state.footer = payload.footer || ''
    },
    setIsLoading(state, payload) {
      state.isLoading = payload.isLoading
    }
  },
  actions: {
  },
  modules: {
  }
})
